export const URLS = {
   sandbox: "https://sandbox-merchant-mgmt.revolut.com",
   prod: "https://merchant-mgmt.revolut.com",
};